import { useQuery } from '@tanstack/react-query';
import { USER_KEY } from '../../utils/constants/queryKeys';
import { getUserInfo } from '../services/idaas/user';
import { useAxiosReady } from 'src/shared/providers/AxiosProvider';

export const useGetUser = () => {
  const { isAxiosReady } = useAxiosReady();

  return useQuery({
    queryKey: [USER_KEY],
    queryFn: getUserInfo,
    enabled: isAxiosReady, // Only run query when axios interceptors are ready
  });
};
